module.exports = __webpack_public_path__ + "static/media/La razon.28c1a809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/La razon.png
// module id = 546
// module chunks = 0